import { Button } from 'darrius';

import { Dialog } from '../../../../components';

import styles from './UnavailableProfileDialog.module.scss';

export default function UnavailableProfileDialog() {
  function handleBackButton() {
    history.back();
  }

  return (
    <Dialog.Root open>
      <Dialog.Portal>
        <Dialog.Content className={styles.dialog}>
          <p className={styles.title}>Profissional indisponível no momento</p>
          <p className={styles.description}>
            Volte para a listagem dos profissionais.
          </p>
          <Button.Root
            variation="primary"
            className={styles.button}
            onClick={handleBackButton}
            size="small"
          >
            Voltar para lista
          </Button.Root>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
